interface UserMessageBubbleProps {
  content: string;
}

export function UserMessageBubble({ content }: UserMessageBubbleProps) {
  return (
    <div className="flex flex-col items-end self-stretch pl-10 lg:pl-0">
      <div className="max-w-[347px] rounded-[4px] bg-[#EBEBEB] px-4 py-3">
        <p className="text-base font-bold leading-6 tracking-[-0.01em] text-[#000000] whitespace-pre-wrap">
          {content}
        </p>
      </div>
    </div>
  );
}
